import { useEffect, useState } from "react";


const useSetting = (key: string) => {

    const [setting, setSetting] = useState<string | null>(null);
    const cacheTime = 1000 * 60 * 5; // 5 minutes
    const cacheKey = `setting_${key}`;

    useEffect(() => {
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
            const parsed = JSON.parse(cached);
            if (Date.now() - parsed.timestamp < cacheTime) {
                setSetting(parsed.value);
                return;
            }
        }

        fetch(`https://api.stacher.io/api/hp/${key}`)
            .then(res => res.json())
            .then(data => {
                setSetting(data.value);
                localStorage.setItem(cacheKey, JSON.stringify({ value: data.value, timestamp: Date.now() }));
            })
            .catch(err => {
                setSetting(null);
            });
    }, [key]);

    return setting;
}

export default useSetting;